import { useCallback } from 'react';
import { useSocketClient } from 'providers/SocketContext';
import { useAppDispatch, useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectSectionStylesById, setSectionStyles } from 'components/editor/grid/reduxStore/editorSlice';
import { setSaveStatus, setSaveStatusBasedOnApiResponse } from 'components/editor/grid/reduxStore/saveStatusSlice';
import { SectionEvents } from 'services/socket/SocketEvents';
import type { DefaultSocketResponseType } from 'services/socket/SocketEvents';
import { DocumentSaveStatus } from 'components/editor/shared/models/DocumentSaveStatus';
import type { SectionStyles } from 'components/editor/Sections/Section.model';

export function useSectionStylesUpdate(sectionId: string) {
  const { socketClient } = useSocketClient();
  const dispatch = useAppDispatch();
  const currentStyles = useAppSelector((state) => selectSectionStylesById(state, sectionId));

  const updateStyles = useCallback(
    (newStyles: SectionStyles) => {
      dispatch(setSectionStyles({ sectionId, styles: newStyles }));
      dispatch(setSaveStatus({ status: DocumentSaveStatus.SAVING }));
      socketClient.publish(
        SectionEvents.SECTION_SETTINGS_CHANGED,
        { sectionId, styles: newStyles },
        (response: DefaultSocketResponseType) => {
          dispatch(setSaveStatusBasedOnApiResponse(response));
        }
      );
    },
    [sectionId, dispatch, socketClient]
  );

  return { currentStyles, updateStyles };
}
